export type ConnectionBannerState = {
  title: string;
  detail: string;
};

/** Banner copy when edits cannot reach the server, or null while it is reachable. */
export function connectionBannerState(input: {
  browserOnline: boolean;
  serverUnreachable: boolean;
}): ConnectionBannerState | null {
  if (!input.browserOnline) {
    return {
      title: "You're offline",
      detail: "Changes can't be saved until the connection returns. Keep this page open.",
    };
  }
  if (input.serverUnreachable) {
    return {
      title: "Can't reach the server",
      detail: "Changes can't be saved right now. Retrying automatically.",
    };
  }
  return null;
}
